import Select from "react-select";
import { useField, useFormikContext } from "formik";

const AppSelect2Field = ({
  name,
  options,
  placeholder = "Select...",
  isMulti = false,
  isDisabled = false,
}) => {
  const { setFieldValue, setFieldTouched } = useFormikContext();
  const [field, meta] = useField(name);

  const hasError = meta.touched && meta.error;

  return (
    <>
      <Select
        inputId={name}
        name={name}
        options={options}
        placeholder={placeholder}
        isMulti={isMulti}
        isDisabled={isDisabled}
        value={
          isMulti
            ? options.filter(option =>
                field.value?.includes(option.value)
              )
            : options.find(option => option.value === field.value) || null
        }
        onChange={(selected) => {
          if (isMulti) {
            setFieldValue(
              name,
              selected ? selected.map(opt => opt.value) : []
            );
          } else {
            setFieldValue(name, selected ? selected.value : "");
          }
        }}
        onBlur={() => setFieldTouched(name, true)}
        classNamePrefix="react-select"
        className={hasError ? "is-invalid" : ""}
        styles={bootstrapSelectStyles(hasError)}
      />

      {hasError && (
        <div className="invalid-feedback d-block">
          {meta.error}
        </div>
      )}
    </>
  );
};

const bootstrapSelectStyles = (hasError) => ({
  control: (base, state) => ({
    ...base,
    minHeight: "38px",
    borderRadius: "0.375rem",
    borderColor: hasError
      ? "#dc3545"
      : state.isFocused
      ? "#86b7fe"
      : "#ced4da",
    boxShadow: state.isFocused
      ? "0 0 0 0.25rem rgba(13,110,253,.25)"
      : "none",
    "&:hover": {
      borderColor: state.isFocused
        ? "#86b7fe"
        : "#ced4da",
    },
  }),
  valueContainer: (base) => ({
    ...base,
    padding: "0.375rem 0.75rem",
  }),
  input: (base) => ({
    ...base,
    margin: 0,
    padding: 0,
  }),
  indicatorsContainer: (base) => ({
    ...base,
    height: "38px",
  }),
  menu: (base) => ({
    ...base,
    zIndex: 9999,
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? "#0d6efd"
      : state.isFocused
      ? "#e9ecef"
      : "white",
    color: state.isSelected ? "white" : "#212529",
  }),
});


export default AppSelect2Field;
